// ========= 1) Enums: khai báo key chuẩn =========
export enum TicketFieldKey {
  // Ticket
  content = 'content',
  isNotOnTime = 'isNotOnTime',
  numOfRequests = 'numOfRequests',
  isPriority = 'isPriority',
  isDoubleCheck = 'isDoubleCheck',
  isRequestMultipleTime = 'isRequestMultipleTime',
  cmisRequestId = 'cmisRequestId',
  statusId = 'statusId',
  customerRequestName = 'customerRequestName',
  customerRequestAddress = 'customerRequestAddress',
  customerRequestPhoneNumber = 'customerRequestPhoneNumber',
  customerRequestCicNumber = 'customerRequestCicNumber',
  customerRequestCicIssueDate = 'customerRequestCicIssueDate',
  customerRequestCicIssuePlace = 'customerRequestCicIssuePlace',
  customerRequestCicType = 'customerRequestCicType',
  channelId = 'channelId',
  serviceTypeId = 'serviceTypeId',
  appointmentDate = 'appointmentDate',

  // Additional Info
  phaseNumber = 'phaseNumber',
  usagePurpose = 'usagePurpose',
  outageAt = 'outageAt',
  outageReasonId = 'outageReasonId',
  isOutageEntireArea = 'isOutageEntireArea',
  isNotRequestToSendSms = 'isNotRequestToSendSms',
  powerRestorationAt = 'powerRestorationAt',
  incidentAddress = 'incidentAddress',
  incidentAdministrativeUnitId = 'incidentAdministrativeUnitId',

  // Transfer / Update flags
  transferToCSKHFromTruongCa = 'transferToCSKHFromTruongCa',
  transferToKyThuatFromTruongCa = 'transferToKyThuatFromTruongCa',
  transferToTruongCaFromKyThuat = 'transferToTruongCaFromKyThuat',
  transferToCSKHFromKyThuat = 'transferToCSKHFromKyThuat',
  transferToKyThuatFromCSKH = 'transferToKyThuatFromCSKH',
  transferToTruongCaFromCSKH = 'transferToTruongCaFromCSKH',
  updateFromTruongCa = 'updateFromTruongCa',
  updateFromKyThuat = 'updateFromKyThuat',
  updateFromCSKH = 'updateFromCSKH'
}

export enum TicketFieldGroup {
  Ticket = 'Ticket',
  AdditionalInfo = 'AdditionalInfo',
  TransferUpdate = 'TransferUpdate'
}

export const FIELD_LABEL_TRANSLATION: Record<string, string> = {
  // Ticket
  content: 'Nội dung yêu cầu',
  isNotOnTime: 'Yêu cầu quá hạn',
  numOfRequests: 'Cập nhật số lần gọi',
  isPriority: 'Ưu tiên',
  isDoubleCheck: 'Cần đối soát',
  isRequestMultipleTime: 'Yêu cầu nhiều lần',
  cmisRequestId: 'Mã yêu cầu CMIS',
  statusId: 'Trạng thái (ID)',
  customerRequestName: 'Tên khách hàng',
  customerRequestAddress: 'Địa chỉ khách hàng',
  customerRequestPhoneNumber: 'Số điện thoại khách hàng',
  customerRequestCicNumber: 'Số giấy tờ khách hàng',
  customerRequestCicIssueDate: 'Ngày cấp giấy tờ',
  customerRequestCicIssuePlace: 'Nơi cấp giấy tờ',
  customerRequestCicType: 'Loại giấy tờ',
  channelId: 'Kênh tiếp nhận (ID)',
  serviceTypeId: 'Loại dịch vụ (ID)',
  appointmentDate: 'Ngày hẹn',

  // Additional Info
  phaseNumber: 'Số pha',
  usagePurpose: 'Mục đích sử dụng điện',
  outageAt: 'Thời điểm mất điện',
  outageReasonId: 'Lý do mất điện (ID)',
  isOutageEntireArea: 'Mất điện toàn khu vực',
  isNotRequestToSendSms: 'Không yêu cầu gửi SMS',
  powerRestorationAt: 'Thời điểm có điện lại',
  incidentAddress: 'Địa chỉ sự cố',
  incidentAdministrativeUnitId: 'Đơn vị hành chính sự cố (ID)',

  // Transfer actions
  transferToCSKHFromTruongCa: 'Trưởng ca chuyển CSKH',
  transferToKyThuatFromTruongCa: 'Trưởng ca chuyển Kỹ thuật',
  transferToTruongCaFromKyThuat: 'Kỹ thuật chuyển Trưởng ca',
  transferToCSKHFromKyThuat: 'Kỹ thuật chuyển CSKH',
  transferToKyThuatFromCSKH: 'CSKH chuyển Kỹ thuật',
  transferToTruongCaFromCSKH: 'CSKH chuyển Trưởng ca',

  // Update actions
  updateFromTruongCa: 'Trưởng ca cập nhật',
  updateFromKyThuat: 'Kỹ thuật cập nhật',
  updateFromCSKH: 'CSKH cập nhật'
};
